import React, {useState} from 'react';
import {Grid, Typography} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import Button from '../../core/input/Button';
import StripeAccountDialog from './StripeAccountDialog';
import {useAffiliateGetStripeAccountDashboard} from '../../../hooks/useAffiliate';
import IconButton from '@material-ui/core/IconButton';
import SettingsIcon from '@material-ui/icons/Settings';

const AffiliateStripe = ({affiliate}) => {
	const {t} = useTranslation();
	const [showDialog, setShowDialog] = useState(false);
	const [getStripeAccount, getting] = useAffiliateGetStripeAccountDashboard();

	const handleManage = () => {
		getStripeAccount().then(d => {
			if (d && d.url) {
				window.location.href = d.url;
			}
		});
	};

	return (
		<Grid container>
			<Grid item xs={12}>
				{affiliate.Dedicated_Stripe_Account &&
					(
						<Grid container alignItems={'center'}>
							<Grid item xs={10}>
								<Typography color="textPrimary" component="p" align='center' variant='subtitle1'>
									{affiliate.Dedicated_Stripe_Account}
								</Typography>
							</Grid>
							<Grid item xs={2}>
								<IconButton
									size="small"
									disabled={getting}
									onClick={handleManage}
								>
									<SettingsIcon/>
								</IconButton>
							</Grid>
						</Grid>
					)
				}
				{!affiliate.Dedicated_Stripe_Account &&
						<Grid item xs={12} style={{ textAlign: 'center' }}>
							<Button
								size='small'
								color='primary'
								type='button'
								variant='contained'
								onClick={() => setShowDialog(true)}

							>
								{t('create_stripe_btn')}
							</Button>
						</Grid>
				}
				{!affiliate.Dedicated_Stripe_Account &&
					<StripeAccountDialog affiliate={affiliate} setOpen={setShowDialog} open={showDialog}/>}
			</Grid>
		</Grid>);
};

export default AffiliateStripe;

AffiliateStripe.propTypes = {
	affiliate: PropTypes.object.isRequired
};
